import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { attendanceService } from "../../api/attendanceService";

// Server time minus device time, measured once. The midpoint of the
// request is used so network delay doesn't skew it.
const fetchOffset = async () => {
  const sentAt = Date.now();
  const { serverTime } = await attendanceService.getServerTime();
  const receivedAt = Date.now();
  return new Date(serverTime).getTime() - (sentAt + receivedAt) / 2;
};

// The official (server) clock, ticking locally every second.
// `now` stays null until the server answered: the device clock is never
// shown as the official time.
export const useServerClock = () => {
  const offsetQuery = useQuery({
    queryKey: ["me:attendance", "server-time-offset"],
    queryFn: fetchOffset,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true, // the device may have slept or changed its clock
  });
  const offset = offsetQuery.data;
  const [now, setNow] = useState(null);

  useEffect(() => {
    if (offset == null) return undefined;
    const tick = () => setNow(new Date(Date.now() + offset));
    const first = setTimeout(tick, 0);
    const timer = setInterval(tick, 1000);
    return () => {
      clearTimeout(first);
      clearInterval(timer);
    };
  }, [offset]);

  return { now: offset == null ? null : now, isError: offsetQuery.isError };
};
